module.exports = __webpack_public_path__ + "static/3rd_Banner_MezzeBites-0ad50db46e98cb0d956b7751fe5d68c3.jpg";